import React, { Component } from 'react';

import moment from 'moment';

import Dialog from 'material-ui/Dialog';
import { List } from 'material-ui/List';
import Menu from 'material-ui/Menu';
import Popover from 'material-ui/Popover';

import * as ParseService from '../../../services/parse';

import AssignmentListItem from './AssignmentListItem';
import TagList, { TagListButton } from './TagList';

function AssignmentListHeader(props) {
  const { date, period, onTagClick } = props;

  const startOfWeek = moment(date).startOf(period);
  const endOfWeek = moment(date).endOf(period);

  const headerDateFormat = 'ddd, M/D/YY';

  return (
    <div className="list-content__header main-assignment-list">
      <p className="list-content__header__headline">{startOfWeek.format(headerDateFormat)} - {endOfWeek.format(headerDateFormat)}</p>
      <TagListButton onClick={onTagClick} />
    </div>
  ); 
}

class AssignmentList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      tags: [],
      tagsOpen: false,
      tagsAnchorEl: null,
    }

  }

  fetchItems(targetDate) {
    const period = this.props.period;

    const startOfWeek = moment(targetDate).startOf(period);
    const endOfWeek = moment(targetDate).endOf(period);
    
    const that = this;
    
    ParseService.findAssignmentsDueInRange(startOfWeek.toDate(), endOfWeek.toDate(), {
      success: function(results) {
        that.setState({items: results});
      },
      error: function(err) {
        console.log("Failed to fetch Assignments " + err);
        that.setState({items: []});
      }
    });
  }

  fetchTags() {
    const that = this;

    ParseService.findTags({
      success: function(results) {
        that.setState({tags: results})
      },
      error: function(err) {
        that.setState({tags: []});
      }
    });
  }

  componentWillReceiveProps(props) {
    console.log("AssignmentList#willReceiveProps");
    this.fetchItems(props.date);
  }

  componentDidMount() {
    this.fetchItems(this.props.date);
    this.fetchTags();
  }

  handleTagClick = (e) => {
    this.setState({
      tagsOpen: true,
      tagsAnchorEl: e.currentTarget,
    });
  }

	render() {
    const items = this.state.items;
    const date = this.props.date;
    const period = this.props.period;

		return (  
			<div className="scene-main-content-box">
        <div className="list-content">
          <AssignmentListHeader 
            date={date} 
            period={period}
            onTagClick={this.handleTagClick} />

          <div className="list-content__list">
    				<List>
              {items.map((item) =>
                <AssignmentListItem
                  key={item.id}
                  onItemSelected={this.props.onItemSelected}
                  item={item}
                  onProgressChange={this.props.onProgressChange}
                />
              )}
    				</List>
          </div>
        </div>

        { this.state.tagsOpen ? (
          <TagList items={this.state.tags} onClose={() => this.setState({tagsOpen: false})} />
        ) : null }
      </div>
    );
  }
}

export default AssignmentList;


// WEBPACK FOOTER //
// ./src/scenes/Assignments/components/AssignmentList.js